module.exports = __webpack_public_path__ + "cf.svg?8f764c6dedaca265cead5bd746224551";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/cf.svg
// module id = 1036
// module chunks = 0